module.exports = __webpack_public_path__ + "img/1 (76).51f01368.png";